import { hot } from 'react-hot-loader/root';
import Component from './resetPassword-redux';

export default hot(Component);
